import axios from "axios";
import authHeader from '@/services/auth/AuthHeader';

class ReportService {
    getDataForReportGui(){
        let user = JSON.parse(localStorage.getItem('user'));
        let url = '/api/report/getDataForReportGui' + '?merchant=' + user.merchant;
        let basicAuth = authHeader();
        return axios.get(url, { headers: basicAuth });
    }

    getXReport(locationId, terminalId){
        let user = JSON.parse(localStorage.getItem('user'));
        let url = '/api/report/getXReport' + '?merchant=' + user.merchant + '&locationId=' + locationId + '&terminalId=' + terminalId;
        let basicAuth = authHeader();
        return axios.get(url, { headers: basicAuth });
    }

    getXReportForDate(locationId, terminalId, date){
        let user = JSON.parse(localStorage.getItem('user'));
        let url = '/api/report/getXReportForDate' + '?merchant=' + user.merchant + '&locationId=' + locationId + '&terminalId=' + terminalId + '&date=' + date;
        let basicAuth = authHeader();
        return axios.get(url, { headers: basicAuth });
    }

    getZReport(locationId, terminalId, selectedDate){
        let user = JSON.parse(localStorage.getItem('user'));
        let url = '/api/report/getZReport' + '?merchant=' + user.merchant + '&locationId=' + locationId + '&terminalId=' + terminalId + '&date=' + selectedDate;
        let basicAuth = authHeader();
        return axios.get(url, { headers: basicAuth });
    }
    getWebshopXReportCountersForDate(locationId, date){
        let user = JSON.parse(localStorage.getItem('user'));
        let url = '/api/report/getWebshopXReportCountersForDate' + '?merchant=' + user.merchant + '&locationId=' + locationId + '&date=' + date;
        let basicAuth = authHeader();
        return axios.get(url, { headers: basicAuth });
    }

    createZReport(locationId, terminalId){
        let user = JSON.parse(localStorage.getItem('user'));
        let url = '/api/report/createZReport' + '?merchant=' + user.merchant + '&locationId=' + locationId + '&terminalId=' + terminalId;
        let basicAuth = authHeader();
        return axios.get(url, { headers: basicAuth });
    }

    createZReportForDate(locationId, terminalId, date){
        let user = JSON.parse(localStorage.getItem('user'));
        let url = '/api/report/createZReportForDate' + '?merchant=' + user.merchant + '&locationId=' + locationId + '&terminalId=' + terminalId + '&date=' + date;
        let basicAuth = authHeader();
        return axios.get(url, { headers: basicAuth });
    }

    createAllWebshopZReports(locationId, date){
        let user = JSON.parse(localStorage.getItem('user'));
        let url = '/api/report/createAllWebshopZReports' + '?merchant=' + user.merchant + '&locationId=' + locationId + '&fromDate=' + date;
        let basicAuth = authHeader();
        return axios.get(url, { headers: basicAuth });
    }

    getTotalSalesReport(locationId, terminalId, fromDate, toDate){
        let user = JSON.parse(localStorage.getItem('user'));
        let url = '/api/report/getTotalSalesReport' + '?merchant=' + user.merchant + '&locationId=' + locationId + '&terminalId=' + terminalId + '&fromDate=' + fromDate + '&toDate=' + toDate;
        let basicAuth = authHeader();
        return axios.get(url, { headers: basicAuth });
    }

    getAlcoholReport(locationId, fromDate, toDate){
        let user = JSON.parse(localStorage.getItem('user'));
        let url = '/api/report/getAlcoholReport' + '?merchant=' + user.merchant + '&locationId=' + locationId + '&fromDate=' + fromDate + '&toDate=' + toDate;
        let basicAuth = authHeader();
        return axios.get(url, { headers: basicAuth });
    }

    /** Speed of service: kitchen time, punctuality, waiting at the counter (TastyKDS phase 3, item 16). */
    getKitchenTimesReport(locationId, fromDate, toDate){
        let user = JSON.parse(localStorage.getItem('user'));
        let url = '/api/report/getKitchenTimesReport' + '?merchant=' + user.merchant + '&locationId=' + locationId + '&fromDate=' + fromDate + '&toDate=' + toDate;
        let basicAuth = authHeader();
        return axios.get(url, { headers: basicAuth });
    }

    getSmsReport(locationId, fromDate, toDate){
        let user = JSON.parse(localStorage.getItem('user'));
        let url = '/api/report/getSmsReport' + '?merchant=' + user.merchant + '&locationId=' + locationId + '&fromDate=' + fromDate + '&toDate=' + toDate;
        let basicAuth = authHeader();
        return axios.get(url, { headers: basicAuth });
    }

    getTransactionsReport(fromDate, toDate){
        let user = JSON.parse(localStorage.getItem('user'));
        let url = '/api/report/getTransactionsReport' + '?merchant=' + user.merchant + '&fromDate=' + fromDate + '&toDate=' + toDate;
        let basicAuth = authHeader();
        return axios.get(url, { headers: basicAuth });
    }

    uploadSaftFile(file){
        let basicAuth = authHeader();
        basicAuth['content-type'] = 'multipart/form-data';
        let formData = new FormData();
        formData.append('file', file);
        return axios.post('/api/journal/uploadSaft', formData, { headers: basicAuth });
    }

    generateEventReports(locationId, terminalDocumentId, fromDate, toDate){
        let user = JSON.parse(localStorage.getItem('user'));
        let url = '/api/journal/generateEventReports' + '?merchant=' + user.merchant +
            '&locationId=' + locationId +
            '&terminalDocumentId=' + terminalDocumentId +
            '&fromDate=' + fromDate +
            '&toDate=' + toDate;

        let basicAuth = authHeader();
        return axios.get(url, { headers: basicAuth });
    }

    generateSaftReport(locationId, terminalDocumentId, fromDate, toDate){
        let user = JSON.parse(localStorage.getItem('user'));
        let url = '/api/journal/generateSaft' + '?merchant=' + user.merchant +
            '&locationId=' + locationId +
            '&terminalDocumentId=' + terminalDocumentId +
            '&fromDate=' + fromDate +
            '&toDate=' + toDate;

        let basicAuth = authHeader();
        return axios.get(url, { headers: basicAuth });
    }
}

export default new ReportService();
